export default __webpack_public_path__ + "static/BigLift2-0078ff335505285b9dc3b7767235ebfe.gif";